import {findDeliveryPreferentialOriginDocumentsByFilter, findDeliveryPreferentialOriginDocumentsByReportCriteria, findForwarders, findManufacturerCountryOfOrigins} from "../graphql/pod/generated/queries";
import {GraphQlService} from "./GraphQlService";
import {gql} from "@apollo/client";
import {LinkDeliveryPreferentialOriginDocumentInput, ReportCriteriaInput} from "../graphql/pod/generated/api";
import {storePreferentialOriginDocumentForLinkingDelivery} from "../graphql/pod/generated/mutations";

export class PODService {
    constructor(private graphQlService: GraphQlService) {
    }

    async findForwarders(): Promise<any> {
        return this.graphQlService.apolloClient.query({
            query: gql`${findForwarders}`
        });
    }

    async findManufacturerCountryOfOrigins(): Promise<any> {
        return this.graphQlService.apolloClient.query({
            query: gql`${findManufacturerCountryOfOrigins}`
        });
    }

    async findDeliveryPreferentialOriginDocumentsByFilter(searchField: string): Promise<any[]> {
        try {
            const result = await this.graphQlService.apolloClient.query({
                query: gql`${findDeliveryPreferentialOriginDocumentsByFilter}`,
                variables: { filter: searchField },
                fetchPolicy: 'no-cache',
            });
            return result?.data?.findDeliveryPreferentialOriginDocumentsByFilter || [];
        } catch (err: any) {
            if (err?.name === 'ApolloError' && err?.message?.includes("Server response was missing for query")) {
                console.warn('Server returned empty body; substituting empty array.');
                return [];
            }
            console.error('Unhandled POD fetch error:', err);
            throw err;
        }
    }

    async mutateDeliveryPodData(inputs: Array<LinkDeliveryPreferentialOriginDocumentInput>): Promise<any> {
        return this.graphQlService.apolloClient.mutate({
            mutation: gql`${storePreferentialOriginDocumentForLinkingDelivery}`,
            variables: {inputs: inputs}
        });
    }

    async findDeliveryPreferentialOriginDocumentsByReportCriteria(criteria: ReportCriteriaInput): Promise<any> {
        try {
            const result = await this.graphQlService.apolloClient.query({
                query: gql`${findDeliveryPreferentialOriginDocumentsByReportCriteria}`,
                variables: { criteria: criteria },
                fetchPolicy: 'no-cache',
            });
            return result?.data?.findDeliveryPreferentialOriginDocumentsByReportCriteria || [];
        } catch (err: any) {
            if (err?.name === 'ApolloError' && err?.message?.includes("Server response was missing for query")) {
                console.warn('Server returned empty body; substituting empty array.');
                return [];
            }
            console.error('Unhandled POD fetch error:', err);
            throw err;
        }
    }
}